// extracted by mini-css-extract-plugin
export default {"kTextbox":"AgriculturalUseCategoriesOfLandTable_kTextbox__unvCC","GreyedOut":"AgriculturalUseCategoriesOfLandTable_GreyedOut__imqUT"};